<template lang="pug">
.sell-record-detail.d-flex.flex-column.h-100
  .custom-header.d-flex.sticky-top
    //- CustomTab.flex-fill(
    //-   :tabItems='tabItems'
    //-   v-model='selectedTab'
    //- )
    button.transparent-button.ml-auto(@click='$emit(`closeButtonClicked`)')
      i.fa.fa-times(style='font-size: 24px; padding: 12px 16px;')

  Detail(
    :customer='customer'
    :quotation='quotation'
  )

  .d-flex.justify-content-center.mt-2.mb-4
    button.btn.btn-secondary.mr-3(@click='$emit(`closeButtonClicked`)')
      | ยกเลิก
    button.btn.btn-upa-secondary.ml-3(@click='$emit(`makeASellButtonClicked`)')
      | สร้างรายการขาย
</template>

<script>
import CustomerCompactDetailHeader from '@/components/customers/CustomerCompactDetailHeader.vue';

import Detail from './Detail.vue';

export default {
  props: {
    customer: {
      default: () => ({}),
    },
    quotation: {
      default: () => ({}),
    },
  },
  // computed: {
  //   formattedDate() {
  //     return this.$moment(this.quotation.date).format('D MMMM YYYY');
  //   },
  //   formattedTime() {
  //     return this.$moment(this.quotation.time).format('HH:mm');
  //   },
  // },
  data: () => ({
  }),
  components: {
    CustomerCompactDetailHeader,

    Detail,
    History,
  },
};
</script>

<style lang="scss">
// .sell-record-detail {}
.custom-header {
  background: #fff;
  // padding-bottom: 8px;
}
</style>
